(function(){
  const qs=(s,c=document)=>c.querySelector(s), qsa=(s,c=document)=>[...c.querySelectorAll(s)];
  const overlay=qs('#LoomerOverlay'), drawer=qs('#LoomerCartDrawer');
  function overlayOn(){ if(overlay) overlay.hidden=false; document.body.classList.add('overlay-open'); }
  function overlayOff(){ if(overlay) overlay.hidden=true; document.body.classList.remove('overlay-open'); }
  function closePanels(){
    if(drawer) drawer.classList.remove('is-open');
    qs('#SearchOverlay')?.classList.remove('is-open');
    qs('#FitDrawer')?.classList.remove('is-open');
    qs('#BackStockDrawer')?.classList.remove('is-open');
    overlayOff();
  }
  async function refreshCart(){
    try{
      const r=await fetch('/cart.js',{headers:{Accept:'application/json'}}); if(!r.ok) return; const cart=await r.json();
      qsa('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);
      const body=qs('[data-cart-lines]'), subtotal=qs('[data-cart-subtotal]');
      if(body){ body.innerHTML=cart.items.map(item=>`<div class="cart-line"><img src="${item.image||''}" alt=""><div><div class="product-card__name">${item.product_title||''}</div><div class="muted">${item.variant_title||''}</div><div>${window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(item.final_line_price):item.final_line_price/100}</div><button class="icon-button" data-remove-line="${item.key}">Remove</button></div></div>`).join('') || '<p>Your cart is empty.</p>'; }
      if(subtotal) subtotal.textContent=window.Shopify&&Shopify.formatMoney?Shopify.formatMoney(cart.total_price):(cart.total_price/100).toFixed(2);
    }catch(err){ console.warn('LOOMER cart refresh failed',err); }
  }
  function openCart(){ closePanels(); if(drawer){drawer.classList.add('is-open'); overlayOn(); refreshCart();} }

  document.addEventListener('click',async e=>{
    if(e.target.closest('[data-cart-open]')){e.preventDefault();openCart();return;}
    if(e.target.closest('[data-cart-close]')||e.target===overlay){closePanels();return;}
    if(e.target.closest('[data-mobile-toggle]')){qs('#MobileMenu')?.classList.toggle('is-open');return;}
    const rem=e.target.closest('[data-remove-line]'); if(rem){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:rem.dataset.removeLine,quantity:0})});refreshCart();return;}
    const quick=e.target.closest('[data-quick-add]'); if(quick){e.preventDefault();quick.disabled=true;try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(quick.dataset.quickAdd),quantity:1}]})});if(r.ok)openCart();}finally{quick.disabled=false;}return;}
    const fit=e.target.closest('[data-fit-open]'); if(fit){closePanels();qs('#FitDrawer')?.classList.add('is-open');overlayOn();return;}
    if(e.target.closest('[data-fit-close]')){closePanels();return;}
    if(e.target.closest('[data-back-stock]')){closePanels();qs('#BackStockDrawer')?.classList.add('is-open');overlayOn();return;}
    if(e.target.closest('[data-back-stock-close]')){closePanels();return;}
    if(e.target.closest('[data-sticky-atc]')){const b=qs('[data-product-submit]');if(b&&!b.disabled)b.click();return;}
    const wish=e.target.closest('[data-wishlist]'); if(wish){const key='loomer_wishlist',arr=JSON.parse(localStorage.getItem(key)||'[]'),h=wish.dataset.wishlist,i=arr.indexOf(h);if(i>-1){arr.splice(i,1);wish.textContent='♡';}else{arr.push(h);wish.textContent='♥';}localStorage.setItem(key,JSON.stringify(arr));return;}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closePanels();});

  qsa('form[data-ajax-product-form]').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault(); const btn=qs('[type="submit"]',form); if(btn)btn.disabled=true;
    try{const fd=new FormData(form); const r=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd}); if(r.ok)openCart();}
    finally{if(btn)btn.disabled=false;}
  }));

  function updateProductVariant(sel){
    if(!sel || !sel.options) return;
    const opt=sel.options[sel.selectedIndex]; if(!opt) return;
    const price=opt.dataset.price||'', compare=opt.dataset.comparePrice||'', available=opt.dataset.available==='true';
    const wrap=sel.closest('[data-product-root]'), priceEl=qs('[data-product-price]',wrap), compareEl=qs('[data-product-compare-price]',wrap), priceWrap=qs('[data-product-price-wrap]',wrap), saleBadge=qs('[data-pdp-sale-badge]',wrap), btn=qs('[data-product-submit]',wrap), stock=qs('[data-stock-status]',wrap), notify=qs('[data-back-stock]'), backVariant=qs('[data-back-stock-variant]');
    if(priceEl&&price) priceEl.textContent=price;
    if(compareEl){compareEl.textContent=compare;compareEl.hidden=!compare;}
    if(priceWrap) priceWrap.classList.toggle('is-sale',Boolean(compare));
    if(saleBadge) saleBadge.hidden=!compare;
    qsa('[data-sticky-price]').forEach(el=>{if(price)el.textContent=price;});
    if(btn){btn.disabled=!available;btn.textContent=available?'Add to cart':'Sold out';}
    if(stock)stock.innerHTML=available?'<span class="stock-dot"></span> In stock':'Sold out';
    if(notify)notify.hidden=available;
    if(backVariant)backVariant.value=opt.textContent.replace(' — Sold out','').trim();
    const mediaId=opt.dataset.mediaId; if(mediaId)qs(`[data-gallery-thumb][data-media-id="${mediaId}"]`,wrap)?.click();
    qsa('[data-variant-choice]',wrap).forEach(choice=>choice.classList.toggle('is-active',String(choice.dataset.variantChoice)===String(opt.value)));
    qsa('.variant-image-swatch',wrap).forEach(choice=>choice.classList.toggle('is-current',String(choice.dataset.variantChoice)===String(opt.value)));
    if(opt.value) history.replaceState({},'',`${location.pathname}?variant=${opt.value}`);
  }
  qsa('select[data-variant-select]').forEach(sel=>sel.addEventListener('change',()=>updateProductVariant(sel)));
  document.addEventListener('click',e=>{
    const choice=e.target.closest('[data-variant-choice]'); if(!choice) return;
    const wrap=choice.closest('[data-product-root]'); if(!wrap) return;
    const sel=qs('select[data-variant-select]',wrap); if(!sel) return;
    const option=[...sel.options].find(o=>String(o.value)===String(choice.dataset.variantChoice)); if(!option) return;
    if(choice.getAttribute('aria-disabled')==='true') return;
    sel.value=option.value; sel.dispatchEvent(new Event('change',{bubbles:true}));
  });

  const searchOpen=qs('[data-search-open]'), searchClose=qs('[data-search-close]'), search=qs('#SearchOverlay'), input=qs('#LoomerSearchInput'), results=qs('#LoomerSearchResults');
  searchOpen?.addEventListener('click',e=>{e.preventDefault();closePanels();search?.classList.add('is-open');overlayOn();input?.focus();});
  searchClose?.addEventListener('click',closePanels);
  let timer; input?.addEventListener('input',()=>{clearTimeout(timer);timer=setTimeout(async()=>{const q=input.value.trim();if(q.length<2){if(results)results.innerHTML='';return;}try{const r=await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);const j=await r.json();const products=j.resources?.results?.products||[];if(results)results.innerHTML=products.map(p=>`<a href="${p.url}" class="product-card"><div class="product-card__media"><img src="${p.image||''}" alt="${p.title||''}"></div><div class="product-card__body"><div class="product-card__name">${p.title||''}</div><div>${p.price||''}</div></div></a>`).join('')||'<p>No products found.</p>';}catch(err){console.warn('LOOMER predictive search failed',err);}},250);});



  /* LOOMER stable product gallery */
  qsa('[data-pdp-gallery]').forEach(gallery=>{
    const slides=qsa('[data-gallery-slide]',gallery), thumbs=qsa('[data-gallery-thumb]',gallery);
    const prev=qs('[data-gallery-prev]',gallery), next=qs('[data-gallery-next]',gallery), current=qs('[data-gallery-current]',gallery), viewport=qs('[data-gallery-viewport]',gallery);
    if(!slides.length)return;
    let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active')));
    const show=i=>{
      if(i<0)i=slides.length-1;
      if(i>=slides.length)i=0;
      index=i;
      slides.forEach((slide,n)=>{
        const active=n===index;
        slide.hidden=!active;
        slide.classList.toggle('is-active',active);
      });
      thumbs.forEach((thumb,n)=>{
        const active=n===index;
        thumb.classList.toggle('is-active',active);
        thumb.setAttribute('aria-pressed',active?'true':'false');
      });
      if(current)current.textContent=String(index+1);
      thumbs[index]?.scrollIntoView({block:'nearest',behavior:'smooth'});
    };
    thumbs.forEach((thumb,n)=>thumb.addEventListener('click',()=>show(n)));
    prev?.addEventListener('click',()=>show(index-1));
    next?.addEventListener('click',()=>show(index+1));
    gallery.addEventListener('keydown',e=>{
      if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}
      if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}
    });
    let startX=null;
    viewport?.addEventListener('touchstart',e=>{startX=e.changedTouches[0]?.clientX??null;},{passive:true});
    viewport?.addEventListener('touchend',e=>{
      if(startX===null)return;
      const endX=e.changedTouches[0]?.clientX??startX, delta=startX-endX;
      startX=null;
      if(Math.abs(delta)<40)return;
      show(delta>0?index+1:index-1);
    },{passive:true});
    show(index);
  });

  const root=qs('[data-product-root]'); if(root?.dataset.productHandle){const key='loomer_recent',h=root.dataset.productHandle,arr=JSON.parse(localStorage.getItem(key)||'[]').filter(x=>x!==h);arr.unshift(h);localStorage.setItem(key,JSON.stringify(arr.slice(0,8)));}
  qsa('[data-wishlist]').forEach(btn=>{const arr=JSON.parse(localStorage.getItem('loomer_wishlist')||'[]');if(arr.includes(btn.dataset.wishlist))btn.textContent='♥';});
})();
